package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository
import fr.manyverse.app.domain.repository.GameTableRepository
import kotlinx.coroutines.delay

class DeleteGameTableUseCase(
    private val gameTableRepository: GameTableRepository,
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        triggeredBy: String,
        playerUserIds: List<String>
    ): Result<Unit> {
        if (playerUserIds.isNotEmpty()) {
            gameEventRepository.createEvent(
                tableId = tableId,
                type = EventType.PLAYER_KICKED,
                triggeredBy = triggeredBy,
                targetParticipants = playerUserIds,
                content = EventContent.PlayerKicked()
            ).onFailure { return Result.failure(it) }
            // Laisser le temps au Realtime de propager l'événement aux clients
            // avant que le CASCADE ne supprime game_table_events
            delay(1500)
        }
        return gameTableRepository.deleteTable(tableId)
    }
}
